import Vue from 'vue';

export default {
	register(instance = Vue) {
		instance.directive('visible', (el, binding) => {
			el.style.visibility = binding.value ? 'visible' : 'hidden';
		});
	},
};
